<template>
  <generic-in-app-screen>
    <div>
      <!-- <c-busy /> -->
      <test-lazy-scroller />
      <test-lazy-display-frozenpanetable-xy />
    </div>
  </generic-in-app-screen>
</template>

<script>
// import CBusy from '@/components/c_busy.vue'
import TestLazyScroller from '@/components/test_lazy_scroller.vue'
import TestLazyDisplayFrozenpanetableXy from '@/components/test_lazy_display_frozenpanetable_xy.vue'

import GenericInAppScreen from '@/components/generic_in_app_screen.vue'

// *****************************************************************************

export default {
  name: 'TestAiplatform',
  components: {
    // CBusy,
    TestLazyScroller,
    TestLazyDisplayFrozenpanetableXy,
    GenericInAppScreen,
  },
}
</script>
